const Vehicle = () =>
  import(
    /* webpackChunkName: "vehicle-vehicle" */ '@/pages/transport/vehicles/index.vue'
  )
const CreateVehicle = () =>
  import(
    /* webpackChunkName: "vehicle-vehicle" */ '@/pages/transport/vehicles/create.vue'
  )
const EditVehicle = () =>
  import(
    /* webpackChunkName: "vehicle-vehicle" */ '@/pages/transport/vehicles/edit.vue'
  )

const DetailVehicle = () =>
  import(
    /* webpackChunkName: "vehicle-vehicle" */ '@/pages/transport/vehicles/detail.vue'
  )

export default {
  path: 'vehicle',
  meta: {
    label: 'vehicle',
    auth: 'vehicle'
  },
  component: {
    name: 'Vehicle',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'VehicleReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Vehicle
    },
    {
      name: 'CreateVehicle',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateVehicle
    },
    {
      name: 'EditVehicle',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditVehicle,
      props: true
    },
    {
      name: 'DetailVehicle',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'report'
      },
      component: DetailVehicle,
      props: true
    }
  ]
}
